import { render, staticRenderFns } from "./costBreakdownJC.vue?vue&type=template&id=b12b9cd6&scoped=true&"
import script from "./costBreakdownJC.vue?vue&type=script&lang=js&"
export * from "./costBreakdownJC.vue?vue&type=script&lang=js&"
import style0 from "./costBreakdownJC.vue?vue&type=style&index=0&id=b12b9cd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12b9cd6",
  null
  
)

export default component.exports